import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../styles/OurServices.css';
import serv1 from '../assets/service1.jpg';
import serv2 from '../assets/service2.webp';
import serv3 from '../assets/service3.jpg';
import serv4 from '../assets/service4.jpg';
import serv5 from '../assets/service5.jpg';
import serv6 from '../assets/service6.jpg';
import misc1 from '../assets/misc1.jpg';
import misc2 from '../assets/misc2.jpg';



const services = [
  {
    title: 'Precision Machining',
    image: serv1,
    description: 'We focus on achieving high-precision for our complex components using state-of-the-art CNC/VMC Machines, High quality Cutting Tools, Precise Programming(CAD/CAM), Skilled Machinists, Rigorous Quality Control and a Stable Machining Environment. '
  },
  {
    title: 'Tools & Die Manufacturing',
    image: serv2,
    description: 'We have experience in manufacturing a wide range of tools and dies, including Cutting Dies, Bending Dies, Forging Dies, Injection Molds, Blow Molds and other specialized Tools and Dies.'
  },
  {
    title: 'Prototyping & Production Runs',
    image: serv3,
    description: 'We specialize in both. Our prototyping services are designed to help customers quickly develop and test their designs, while our production runs ensure that we can meet the demands of high-volume manufacturing.'
  },
  {
    title: 'Jigs & Fixtures Manufacturing',
    image: serv4,
    description: `We manufacture custom jigs and fixtures to ensure accuracy and repeatability in the customers' production processes. Our jigs and fixtures are designed to meet the specific needs, ensuring that the parts are machined to the highest standards.`
  },
  {
    title: 'Welding Assemblies',
    image: serv5,
    description: 'We offer welding assembly services for a variety of applications, including structural components, frames, connectors and enclosures to achieve various types of Joints. '
  },
  {
    title: '3D CAD Design & Engineering Support',
    image: serv6,
    description: 'Our team of experienced engineers and designers can help you with everything from initial concept development, 3D Modelling, Designing & Programming, to final product development.'
  }
];

const miscServices = [
  
  'All Types of Surface Treatments',
  'Coating & Plating Services',
  'Reverse Engineering Services',
  'Fabrication Services',
];

export default function OurServices() {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-4">Our Services</h2>
      <Row>
        {services.map((service, idx) => (
          <Col md={6} lg={4} key={idx} className="mb-4">
            <Card className="h-100 service-card">
              <Card.Img variant="top" src={service.image} alt={service.title} />
              <Card.Body>
                <Card.Title>{service.title}</Card.Title>
                <Card.Text>{service.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="mt-5">
        <h2 className="text-center mb-3">We also Provide</h2>
        <Row className="align-items-center">
          <Col md={3} className="d-none d-md-block">
            <img src={misc1} alt="Misc Left" className="img-fluid rounded" />
          </Col>
          <Col md={6}>
            <ul className="misc-services list-unstyled text-center">
              {miscServices.map((item, index) => (
                <li key={index} className="mb-2">{item}</li>
              ))}
            </ul>
          </Col>
          <Col md={3} className="d-none d-md-block">
            <img src={misc2} alt="Misc Right" className="img-fluid rounded" />
          </Col>
        </Row>
      </div>

      <section className="contact-section py-5 bg-custom-dark text-custom-light">
          <Container>
            <Row>
              <Col md={12} className="text-center">
                <h2>Get in Touch</h2>
                <p>Ready to discuss your project? Contact us today!</p>
                <a href="/contact" className="btn btn-primary">Contact Us</a>
              </Col>
            </Row>
          </Container>
        </section>

    </Container>
  );
}
